import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import { env } from 'utils/envManager'

import { PLPQueryParams } from '../../constants/queryParams'
import { RECOMMENDED } from '../useFilters/constants'

interface FilterSearchParams {
	range?: string
	order: string
	filters: string
}

export function useFiltersSearchParams() {
	const pathname = usePathname()
	const searchParams = useSearchParams()
	const router = useRouter()

	function getSearchParams(serializedParams: FilterSearchParams) {
		const current = new URLSearchParams(Array.from(searchParams.entries()))
		current.delete(PLPQueryParams.filters)
		current.delete(PLPQueryParams.order)
		current.delete(PLPQueryParams.range)
		if (serializedParams.range) {
			current.set(PLPQueryParams.range, serializedParams.range)
		}
		if (serializedParams.order !== RECOMMENDED) {
			current.set(PLPQueryParams.order, serializedParams.order)
		}
		if (serializedParams.filters?.length) {
			current.set(PLPQueryParams.filters, serializedParams.filters)
		}
		return current
	}

	function push(serializedParams: FilterSearchParams) {
		const current = getSearchParams(serializedParams)
		const newUrl = new URL(`${env.NEXT_PUBLIC_CURRENT_ORIGIN}${pathname}`)
		newUrl.search = current.toString()
		router.push(newUrl.href, {
			scroll: false,
		})
	}

	function prefetch(serializedParams: FilterSearchParams) {
		const current = getSearchParams(serializedParams)
		const newUrl = new URL(`${env.NEXT_PUBLIC_CURRENT_ORIGIN}${pathname}`)
		newUrl.search = current.toString()
		router.prefetch(newUrl.href)
	}

	return {
		push,
		prefetch,
	}
}
